module.exports = __webpack_public_path__ + "img/Download.ef2f5e58.png";